import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'

import FormView from '@resources/js/components/form/FormView'
import FormStore from '@resources/js/components/form/FormStore'
import { syncFormStoreWithSession } from '@resources/js/components/form/formStoreSync'
import FormPresenter from '@resources/js/components/form/FormPresenter'
import handleCalendarFormSubmit from '@resources/js/helpers/handleCalendarFormSubmit'
import '@resources/js/analytics'
import Sticky from '@resources/js/ui/Sticky'

const partnerType = getBcomOrExpediaPartnerType()

initSharedPromotion()

// спільний стор для форм
const formsStore = new FormStore()
syncFormStoreWithSession(formsStore)

// main form
const mainFormElement = document.querySelector('.js-form')
const mainFormView = new FormView(mainFormElement)
const mainFormPresenter = new FormPresenter(mainFormView, formsStore)

// side form
const sideFormCalendarConfig = {
	showMonths: 1,
	position: 'auto center',
}

const sideFormElement = document.querySelector('.js-side-form')
const sideFormView = new FormView(sideFormElement, {
	calendarConfig: sideFormCalendarConfig,
})
const sideFormPresenter = new FormPresenter(sideFormView, formsStore, 'MMM D')

mainFormPresenter.on('form-submit', formData =>
	handleCalendarFormSubmit({ partnerType, formData })
)
sideFormPresenter.on('form-submit', formData =>
	handleCalendarFormSubmit({ partnerType, formData })
)

const initStickyHeader = () => {
	const headerRootElement = document.querySelector('.js-header')
	const pageMainElement = document.querySelector('.js-pmdgenpost')
	const heroElement = pageMainElement.querySelector('.js-hero')
	const breadcrumbsElement = pageMainElement.querySelector('.js-breadcrumbs')
	const breadcrumbsHeight = breadcrumbsElement?.offsetHeight ?? 0

	const stickyHeaderInstance = new Sticky(headerRootElement, {
		top: heroElement.offsetHeight + breadcrumbsHeight,
		toggleClass: 'passed-hero',
	})

	const handleSetSticky = () => {
		stickyHeaderInstance.off('set-sticky', handleSetSticky)
	}

	stickyHeaderInstance.on('set-sticky', handleSetSticky)
}

initStickyHeader()
